import React from 'react';

const Page4AgreementAndFrontline = ({ 
  agreementResponses, 
  updateAgreementResponse,
  frontlineCareResponse,
  setFrontlineCareResponse,
  handlePrevious,
  handleNext 
}) => {
  console.log("Page4AgreementAndFrontline - Current agreementResponses:", agreementResponses);
  
  const isResponseSelected = (questionKey) => {
    return Object.values(agreementResponses[questionKey]).some(val => val);
  };

  const handleNextWithValidation = () => {
    // Log the responses before proceeding
    const question1Response = getSelectedOption(agreementResponses.question1);
    const question2Response = getSelectedOption(agreementResponses.question2);
    
    console.log("Agreement responses that will be submitted:", {
      'agreement.question1': question1Response,
      'agreement.question2': question2Response,
      'frontlineCare.response': frontlineCareResponse
    });
    
    handleNext();
  };

  const getSelectedOption = (questionResponses) => {
    const options = ['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'];
    for (let i = 1; i <= 4; i++) {
      if (questionResponses[`option${i}`]) {
        return options[i-1];
      }
    }
    return '';
  };

  return (
    <>
      <div className="questions-grid">
        <div className="question-item full-width">
          <label>Do you believe that using Cloudphysician's services has allowed your ICU team to admit and treat more complex cases?</label>
          <div className="rating-options">
            {['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'].map((option, index) => (
              <div key={index} className="rating-option">
                <label 
                  className={`checkbox-label ${agreementResponses.question1[`option${index + 1}`] ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="question1"
                    checked={agreementResponses.question1[`option${index + 1}`]}
                    onChange={() => updateAgreementResponse('question1', `option${index + 1}`)}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="question-item full-width">
          <label>Do you believe that using Cloudphysician's services has allowed your hospital to grow its revenue and brand value?</label>
          <div className="rating-options">
            {['Strongly Agree', 'Agree', 'Disagree', 'Strongly Disagree'].map((option, index) => (
              <div key={index} className="rating-option">
                <label 
                  className={`checkbox-label ${agreementResponses.question2[`option${index + 1}`] ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="question2"
                    checked={agreementResponses.question2[`option${index + 1}`]}
                    onChange={() => updateAgreementResponse('question2', `option${index + 1}`)}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="question-item full-width">
          <label>Are you aware of Cloudphysician's Frontline Critical Care services?</label>
          <div className="rating-options">
            {['Yes', 'No'].map((option) => (
              <div key={option} className="rating-option">
                <label 
                  className={`checkbox-label ${frontlineCareResponse === option.toLowerCase() ? 'selected' : ''}`}
                >
                  <input
                    type="radio"
                    name="frontlineCare"
                    value={option}
                    checked={frontlineCareResponse === option.toLowerCase()}
                    onChange={(e) => setFrontlineCareResponse(e.target.value.toLowerCase())}
                  />
                  <span>{option}</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="button-group">
        <button className="nav-button" onClick={handlePrevious}>Previous</button>
        <button 
          className="nav-button" 
          onClick={handleNextWithValidation}
          disabled={
            !isResponseSelected('question1') || 
            !isResponseSelected('question2') || 
            !frontlineCareResponse
          }
        >
          Next
        </button>
      </div>
    </>
  );
};

export default Page4AgreementAndFrontline; 